export type ApneaSeverity = 'Mild' | 'Moderate' | 'Severe';

export const SEVERITY_PARAM = 'severity';
export const SEVERITIES: ApneaSeverity[] = ['Mild', 'Moderate', 'Severe'];

const titleCase = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

/**
 * Reads ?severity= from the current URL as a validated value, or null when
 * the param is absent/invalid. Use this when you need to distinguish "no
 * severity given" from an explicit value (e.g. QA override state).
 */
export const readSeverityOverride = (): ApneaSeverity | null => {
  if (typeof window === 'undefined') return null;
  const raw = new URLSearchParams(window.location.search).get(SEVERITY_PARAM);
  if (!raw) return null;
  const candidate = titleCase(raw) as ApneaSeverity;
  return SEVERITIES.includes(candidate) ? candidate : null;
};

/**
 * Reads ?severity= from the current URL. Defaults to 'Severe' — this audience
 * is sent into /osa from the app after being classified, so severe is the
 * expected value. Anything outside Mild/Moderate/Severe also falls back.
 */
export const readSeverityFromUrl = (): ApneaSeverity => readSeverityOverride() ?? 'Severe';
